import CheckoutAdvancedFormWithPreview from './CheckoutAdvancedFormWithPreview'

export default CheckoutAdvancedFormWithPreview
